import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';

import { CONSTANT_VALUES } from '../../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../../constants/constants-messages';
import { AppService } from '../../../app.service';
import { FeedService } from './../../../feed/feed.service';
import { EventService } from '../event.service';
import { MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, SetAllMemberCheck } from './../../../shared/message.event';
import { UISETTING } from './../../../shared/ui-setting';
import { UtilityFunctions } from './../../../shared/utility-functions';

@Component({
  selector: 'app-event-broadcast',
  templateUrl: './event-broadcast.component.html',
  styleUrls: ['./event-broadcast.component.css'],
  providers: [MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, FeedService, SetAllMemberCheck, EventService]
})
export class EventBroadcastComponent implements OnInit {
  private shouldSlide: boolean = false;
  private divHeight = 30;
  private pagebutton = 30;
  private vendor: any;
  private clubName = '';
  private groupList = [];
  private createdAt: any;
  private feed: any;

  // Event-specific properties
  public upcomingEvents: any[] = [];
  public selectedEvent: any = null;
  public selectedEventId: string = '';

  // File upload properties
  filesToUpload: any;
  private popUpMessage: any;
  private fileUrl: any;
  private alertMessage = '';
  private alertTitle = 'Alert';

  // Validation - Initialize to prevent undefined errors
  public validationErrors: any = {
    eventError: '',
    titleError: '',
    contentError: '',
    linkError: '',
    recipientError: ''
  };

  // Member and group selection
  private criteria: any;
  private onePagePerItem = 10;
  private pageOptions = {
    currentPage: 1,
    noOfPageItem: this.onePagePerItem
  };
  private currentPage = 1;
  private memberList = [];
  private totalSizeOfList = 0;
  private noMemberAvailable: boolean = true;

  @ViewChild('memberTable') tableVariable: any;
  @ViewChild('fileUploadInput') fileUploadInputVariable: any;
  @ViewChild('popUpObj') popUpObj: any;
  @ViewChild('backPopUpObj') backPopUpObj: any;
  @ViewChild('alertImagePopUpObj') alertImagePopUpObj: any;
  @ViewChild('ViewSelectedpopUpObj') ViewSelectedpopUpObj: any;
  @ViewChild('ViewSelectedGroupPopUpObj') ViewSelectedGroupPopUpObj: any;

  private setChecked = [];
  private isopen = false;
  private selectedCriteria = '';
  private ideal = true;
  private selectedMemberList = [];
  private selectedGroupList = [];
  private memberTableHeight = 55;
  private broadcastToList = CONSTANT_VALUES.BROADCAST_SEND_TO;
  private AddNewMemberFlag = false;
  private cancelForReset = false;
  private addGroupFlagCancel = false;
  private search = '';
  private exp = false;
  private selectNewMembers = [];
  private uiSetting: UISETTING;
  private height: any;
  private utilityFunctions = new UtilityFunctions();
  private urlErr = '';
  private allInGroup = false;

  // Dropdown submenu properties
  private openSubMenu1: boolean = false;
  private openSubMenu2: boolean = false;
  private openSubMenu3: boolean = false;

  // UI properties for template access
  public tt = false;
  public router: Router;
  public Math = Math;
  protected popupTitle: string = 'Information';
  protected cancleButton: boolean = false;

  constructor(
    router: Router,
    private appService: AppService,
    private messageEvent: MessageEvent,
    private signInEvent: SignInEvent,
    private loaderEvent: LoaderEvent,
    private facilityListEvent: FacilityListEvent,
    private openFrameEvent: OpenFrameEvent,
    private feedService: FeedService,
    private setAllMemberCheck: SetAllMemberCheck,
    private eventService: EventService
  ) {
    this.router = router;
    this.uiSetting = {
      'windowHeight': window.innerHeight,
      'topNav': 56,
      'midNav': 45,
      'footer': 35,
      'container': 35
    };
    this.height = 0;

    // Initialize feed object for event broadcast
    this.feed = {
      title: '',
      content: '',
      vendorId: '',
      groups: [],
      members: [],
      sendToAllMembers: false,
      file: '',
      sendOn: '',
      sendToAllGroups: false,
      broadcastLink: '',
      eventId: '',
      facilityId: '',
      eventName: '',
      type: 'EVENT_BROADCAST'
    };

    this.criteria = {
      allMember: false,
      specificMembers: false,
      allGroup: false,
      specificGroup: false
    };

    // Initialize validation errors to prevent undefined access
    this.validationErrors = {
      eventError: '',
      titleError: '',
      contentError: '',
      linkError: '',
      recipientError: ''
    };

    this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer + this.divHeight + this.pagebutton)) + 'px';
  }

  ngOnInit() {
    this.emitOpenFrameEvent();
    window.scrollTo(0, 0);

    // Load vendor data
    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        this.clubName = subVendor.clubName;
      }
    } else {
      this.clubName = this.vendor.clubName;
    }

    this.createdAt = moment(new Date()).format('DD/MM/YYYY');
    this.feed.vendorId = this.getVendorId();

    // Load data
    this.loadUpcomingEvents();
    this.getGroupListByVendor();
    this.pagination(this.pageOptions, 1);
    this.registerTypeBroadcast();
    this.emitTypeBroadcast();
  }

  /**
   * Get vendor ID based on role
   */
  private getVendorId(): string {
    if (this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors && this.vendor.subVendors.length > 0) {
        return this.vendor.subVendors[0]._id;
      }
    }
    return this.vendor._id;
  }

  /**
   * Load upcoming events for selection - ENHANCED VERSION
   */
  private loadUpcomingEvents() {
    this.loaderEvent.fire(false);
    const vendorObj = { vendorId: this.getVendorId() };

    this.eventService.getClubEvents(vendorObj).then((result: any) => {
      if (result.status === 'SUCCESS' && result.eventsData && Array.isArray(result.eventsData)) {
        const allEvents = this.extractEventsFromData(result.eventsData);
        this.upcomingEvents = allEvents.filter(event => this.isEventUpcoming(event));
      } else {
        this.upcomingEvents = [];
      }
      this.loaderEvent.fire(true);
    }).catch(() => {
      this.upcomingEvents = [];
      this.loaderEvent.fire(true);
    });
  }

  private extractEventsFromData(data: any[]): any[] {
    let events = [];
    if (!Array.isArray(data)) return [];

    for (const item of data) {
      if (item.categoryName === 'Events' && item.data && Array.isArray(item.data)) {
        events = events.concat(item.data);
      } else if (this.hasDateField(item)) {
        events.push(item);
      }
    }
    return events;
  }

  private hasDateField(obj: any): boolean {
    if (!obj || typeof obj !== 'object') return false;
    const dateFields = ['date', 'startDate', 'eventDate', 'dateTime'];
    return dateFields.some(field => obj.hasOwnProperty(field));
  }


  /**
   * Check if event is upcoming - ENHANCED VERSION
   */
  private isEventUpcoming(event: any): boolean {
    if (!event) {
      console.log('🔍 DEBUG: Event is null/undefined');
      return false;
    }

    // Check multiple possible date fields
    const eventDate = event.date || event.startDate || event.eventDate || event.dateTime || event.scheduledDate;

    if (!eventDate) {
      console.log('🔍 DEBUG: No date field found for event:', event.name || 'Unknown', 'Available fields:', Object.keys(event));
      return false;
    }

    try {
      let parsedDate: Date;

      if (typeof eventDate === 'string') {
        parsedDate = new Date(eventDate);
      } else if (eventDate instanceof Date) {
        parsedDate = eventDate;
      } else if (typeof eventDate === 'number') {
        parsedDate = new Date(eventDate);
      } else {
        console.log('🔍 DEBUG: Unrecognized date format:', typeof eventDate, eventDate);
        return false;
      }

      if (isNaN(parsedDate.getTime())) {
        console.log('🔍 DEBUG: Invalid date parsed from:', eventDate);
        return false;
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      parsedDate.setHours(0, 0, 0, 0);

      const isUpcoming = parsedDate >= today;
      console.log(`🔍 DEBUG: Event "${event.name || 'Unknown'}" - Date: ${parsedDate.toISOString()}, Today: ${today.toISOString()}, Is Upcoming: ${isUpcoming}`);

      return isUpcoming;
    } catch (error) {
      console.warn('🔍 DEBUG: Error checking date for event:', event.name || 'Unknown', error);
      return false;
    }
  }

  /**
   * Handle event selection change
   */
  public onEventSelectionChange(event: any): void {
    const eventId = event.target.value;
    if (eventId) {
      const selectedEvent = this.upcomingEvents.find(e => e._id === eventId);
      if (selectedEvent) {
        this.selectEvent(selectedEvent);
      }
    } else {
      // Reset if no event is selected
      this.selectedEvent = null;
      this.selectedEventId = '';
      this.feed.eventId = '';
      this.feed.facilityId = '';
      this.feed.eventName = '';
      this.feed.title = '';
      this.feed.content = '';
      // Revert date to current date
      this.createdAt = moment(new Date()).format('DD/MM/YYYY');
    }
  }

  private applyTargetGroups = (evt: any) => {
    const targetIds = Array.isArray(evt.targetGroupIds) ? evt.targetGroupIds : [];

    // Clear previous selections
    this.selectedGroupList = [];
    this.feed.groups = [];

    if (!Array.isArray(this.groupList) || this.groupList.length === 0) {
      this.selectedCriteria = " "
      return;
    }

    // Mark checked state on groupList and build selectedGroupList
    this.groupList.forEach(g => {
      if (targetIds.indexOf(g._id) !== -1) {
        g.checked = true;
        this.selectedGroupList.push(g);
      } else {
        g.checked = false;
      }
    });

    // Ensure uniqueness and populate feed.groups with ids
    this.selectedGroupList = _.uniqBy(this.selectedGroupList, '_id');
    this.feed.groups = this.selectedGroupList.map(g => g._id);
    this.selectedCriteria = "Specific Groups"
  };

  /**
   * Select an event and populate content
   */
  public selectEvent(event: any) {
    this.selectedEvent = event;
    this.selectedEventId = event._id;

    // **MODIFICATION**: Update createdAt to the selected event's date
    if (event.date) {
      this.createdAt = this.formatEventDate(event.date);
    }

    this.feed.eventId = event._id;
    this.feed.facilityId = event._id;
    this.feed.eventName = event.name || event.title;
    this.feed.title = `${event.name || event.title}`;

    // **MODIFICATION**: Generate the full broadcast content
    this.feed.content = this.getEventDescription(event);
    this.validationErrors.eventError = '';

    const targetIds = Array.isArray(event.targetGroupIds) ? event.targetGroupIds : [];

    // If groups already loaded, apply immediately; otherwise load groups then apply
    if (Array.isArray(targetIds) && targetIds.length > 0) {
      this.applyTargetGroups(event);
    } else {
      this.selectedCriteria = ""
      this.feed.groups = [];
      this.criteria.specificGroup = false;
      this.ideal = true;
      this.feed.sendToAllGroups = false;
    }
  }

  /**
    * Generates the broadcast message content based on the selected event's details.
    * @param event The selected event object.
    * @returns A formatted string for the feed content.
    */
  private getEventDescription(event: any): string {
    if (!event) return '';
    const contentParts = [];

    // 1. Add event notes if they exist
    if (event.notes && event.notes.trim()) {
      contentParts.push(event.notes.trim());
    }

    // 2. Add event date
    contentParts.push(`Date: ${this.formatEventDate(event.date)}`);

    // 3. Add event time
    if (event.timings && event.timings.openTime) {
      let timeString = `Time: ${this.formatEventTime(event.timings.openTime)}`;
      if (event.timings.closeTime) {
        timeString += ` - ${this.formatEventTime(event.timings.closeTime)}`;
      }
      contentParts.push(timeString);
    }

    // 4. Add event location
    if (event.location && event.location.trim()) {
      contentParts.push(`Location: ${event.location}`);
    }

    // 5. Add event price
    contentParts.push(`Price: ${this.getEventPrice(event)}`);

    return contentParts.join('\n\n'); // Use double newline for better readability
  }

  /**
* Generates a price string for the event, calculating the total price with GST included.
* @param event The selected event object.
* @returns A formatted price string (e.g., "S$54.00") or "Free".
*/
  private getEventPrice(event: any): string {
    if (event && event.activityCharges && event.activityCharges.member) {
      const memberCharge = event.activityCharges.member;
      if (memberCharge.enabled && memberCharge.amount && parseFloat(memberCharge.amount) > 0) {
        const symbol = memberCharge.currencySymbol || '$';
        let price = parseFloat(memberCharge.amount);

        // Calculate GST and add it to the price
        if (event.isGSTApplicable && event.GSTValue > 0) {
          const gstAmount = price * (event.GSTValue / 100);
          price += gstAmount;
        }

        return `${symbol}${price.toFixed(2)}`;
      }
    }
    return 'Free';
  }


  /**
   * Formats a date string into a more readable format (e.g., "Aug 28, 2025").
   */
  public formatEventDate(dateString: string): string {
    if (!dateString) return '';
    try {
      return moment(dateString).format('MM/DD/YYYY');
    } catch (error) {
      return dateString; // Fallback to original string if formatting fails
    }
  }

  /**
   * Format event time for display
   */
  /**
     * Formats a 24-hour time string into a 12-hour AM/PM format.
     */
  public formatEventTime(timeString: string): string {
    if (!timeString) return '';
    try {
      const timeParts = timeString.split(':');
      const hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1] || '00';
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const displayHours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
      return `${displayHours}:${minutes} ${ampm}`;
    } catch (error) {
      return timeString; // Fallback
    }
  }

  /**
   * Get event open time safely (for template)
   */
  public getEventOpenTime(event: any): string {
    return event && event.timings && event.timings.openTime ? event.timings.openTime : '';
  }

  /**
   * Get event close time safely (for template)
   */
  public getEventCloseTime(event: any): string {
    return event && event.timings && event.timings.closeTime ? event.timings.closeTime : '';
  }

  /**
   * Get event capacity safely - Updated to use maxBookingsPerSlot
   */
  public getEventCapacity(event: any): number {
    if (!event) return 0;

    // Check maxBookingsPerSlot first, then fallback to other capacity fields
    return event.maxBookingsPerSlot ||
      event.capacity ||
      event.maxCapacity ||
      event.totalCapacity ||
      event.maxParticipants ||
      event.participantLimit ||
      0;
  }

  displayEventCapacity(event: any): string {
    if (!event) return '';
    const eventCapacity = this.getEventCapacity(event)
    if (eventCapacity >= 999999) {
      return 'Unlimited';
    }
    return eventCapacity.toString();
  }

  /**
   * Get capacity label based on available data
   */

  public getCapacityLabel(event: any): string {
    if (!event) return '';
    const capacity = this.getEventCapacity(event);
    if (capacity === 0) {
      return 'No booking limit';
    }
    if (capacity === 999999) {
      return 'Unlimited bookings';
    }

    const currentCount = event.currentBookings || 0;
    return `(${currentCount}/${capacity} booked)`;
  }
  /**
   * Get capacity percentage for progress bar
   */
  public getCapacityPercentage(event: any): number {
    if (!event) return 0;
    const capacity = this.getEventCapacity(event);

    if (capacity === 0 || capacity === 999999) {
      return 0;
    }

    const currentCount = event.currentBookings || 0;
    const percentage = (currentCount / capacity) * 100;
    return Math.max(0, Math.min(100, percentage));
  }

  /**
   * Check if event has capacity restrictions
   */
  public hasCapacityLimit(event: any): boolean {
    const capacity = this.getEventCapacity(event);
    return capacity > 0 && capacity !== 999999;
  }

  /**
 * Get available booking slots
 */
  public getAvailableSlots(event: any): number {
    if (!event) return 0;

    const maxSlots = this.getEventCapacity(event);
    if (maxSlots === 0) return 0;

    const currentBookings = event.currentBookings ||
      event.bookedSlots ||
      event.currentRegistrations ||
      0;

    return Math.max(0, maxSlots - currentBookings);
  }

  /**
   * Refresh events list
   */
  public refreshEvents(): void {
    this.upcomingEvents = [];
    this.loadUpcomingEvents();
  }

  /**
   * Create new event
   */
  public createNewEvent() {
    this.router.navigate(['/addevent']);
  }

  /**
   * Navigate to home screen
   */
  public homeScreen(): void {
    this.router.navigate(['/']);
  }

  /**
   * Navigate to feed
   */
  public goToFeed(confirmed?: boolean): void {
    if (confirmed === true || confirmed === undefined) {
      this.resetForm();
      this.router.navigate(['/feed']);
    }
  }

  /**
   * Navigate to events page
   */
  public goToEvents(): void {
    this.router.navigate(['/events']);
  }

  // Event handling methods
  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(message => {
        this.shouldSlide = message;
      });
  }

  emitTypeBroadcast() {
    this.signInEvent.fire('block');
  }

  emitTypeLoaderBroadcast() {
    this.loaderEvent.fire(false);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }

  getGroupListByVendor() {
    let vendorObj = {
      vendorId: this.getVendorId()
    };
    this.appService.getListOfGroup(vendorObj).then((result: any) => {
      if (result.status === 'SUCCESS') {
        this.groupList = result.groups;
      }
    });
  }

  uploadFile(event, alertImagePopUpObj) {
    this.loaderEvent.fire(false);
    this.fileUrl = event.target.files[0];
    let input = event.target;
    let file = input.files[0];
    let that = this;
    let reader = new FileReader();
    if (file) {
      if (file.name.indexOf('.jpg') > 0 || file.name.indexOf('.png') > 0 || file.name.indexOf('.bmp') > 0
        || file.name.indexOf('.jpeg') > 0 || file.name.indexOf('.tiff') > 0) {
        this.readFile(file, reader, (result) => {
          that.filesToUpload = result;
          that.loaderEvent.fire(true);
        });
      } else {
        that.loaderEvent.fire(true);
        that.alertMessage = CONSTANT_MESSAGES.IMAGE_ERROR;
        that.popUpMessage = that.alertMessage;
        that.popupTitle = 'Invalid File';
        that.cancleButton = false;
        if (alertImagePopUpObj && alertImagePopUpObj.showChildModal) {
          alertImagePopUpObj.showChildModal();
        }
      }
    } else {
      this.loaderEvent.fire(true);
    }
  }

  readFile(file, reader, callback) {
    reader.onload = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  }

  /**
   * Remove uploaded image
   */
  public removeImage() {
    this.filesToUpload = '';
    this.feed.file = '';
    if (this.fileUploadInputVariable) {
      this.fileUploadInputVariable.nativeElement.value = '';
    }
  }

  sendFeed(popupObj, backPopUpObj) {
  try {
    const that = this;
    const form_data = new FormData();

    if (!this.validateFeed(popupObj)) {
      return;
    }

    // (Re)build groups & members from selections
    this.feed.groups = [];
    this.feed.members = [];

    this.selectedGroupList = this.selectedGroupList.filter(function (rec: any) {
      that.feed.groups.push(rec._id);
      return rec;
    });

    this.selectedMemberList = this.selectedMemberList.filter(function (rec: any) {
      that.feed.members.push(rec.userId);
      return rec;
    });

    this.loaderEvent.fire(false);

    // --- Event broadcast payload
    form_data.append('title', this.feed.title);
    form_data.append('content', this.feed.content);
    form_data.append('type', 'EVENT_BROADCAST');
    form_data.append('vendorId', this.getVendorId());
    form_data.append('eventId', this.feed.eventId);
    form_data.append('facilityId', this.feed.facilityId);
    form_data.append('eventName', this.feed.eventName);
    form_data.append('groups', this.feed.groups.toString());
    form_data.append('sendToAllMembers', (this.feed.sendToAllMembers).toString());
    form_data.append('members', this.feed.members.toString());
    form_data.append('file', this.fileUrl);
    form_data.append('clubName', this.clubName);
    form_data.append('clubImageUrl', this.vendor.clubImageUrl);
    form_data.append('sendToAllGroups', (this.feed.sendToAllGroups).toString());
    form_data.append('systemUserId', this.getVendorId());
    form_data.append('token', (this.vendor.token));

    // Ensure valid dates
    const sendOnDate = this.createValidSendOnDate();
    form_data.append('sendOn', sendOnDate);

    const validTillDate = this.createValidTillDate();
    form_data.append('validTill', validTillDate);

    const appVersion = localStorage.getItem('appVersion');
    if (appVersion) {
      form_data.append('appVersion', (appVersion).toString());
    }
    form_data.append('deviceType', (CONSTANT_VALUES.DEVICE_TYPE).toString());

    // Optional link
    form_data.append('broadcastLink', (this.feed.broadcastLink).toString());

    // --- Send feed, then update groups with activities = [eventId]
    this.feedService.sendFeed(form_data)
      .then((result: any) => {
        this.loaderEvent.fire(true);
        this.popUpMessage = result.message;
        this.popupTitle = 'Success';
        this.cancleButton = false;
        if (backPopUpObj && backPopUpObj.showChildModal) {
          backPopUpObj.showChildModal();
        }
        this.resetForm();
      })
      .catch((error) => {
        this.loaderEvent.fire(true);
        this.popUpMessage = error && error.message ? error.message : 'Failed to send broadcast. Please try again.';
        this.popupTitle = 'Error';
        this.cancleButton = false;
        if (popupObj && popupObj.showChildModal) {
          popupObj.showChildModal();
        }
      });

  } catch (e) {
    console.error(e);
  }
}

  /**
 * Create a valid sendOn date
 */
  private createValidSendOnDate(): string {
    try {
      const now = new Date();

      // Validate the date object
      if (isNaN(now.getTime())) {
        console.warn('Invalid date created, using fallback');
        return new Date(Date.now()).toISOString();
      }

      return now.toISOString();
    } catch (error) {
      console.error('Error creating sendOn date:', error);
      // Fallback to current timestamp
      return new Date(Date.now()).toISOString();
    }
  }

  /**
   * Create a valid validTill date
   */
  private createValidTillDate(): string {
    try {
      let validTillDate = new Date();

      // Set based on selected event date or default
      if (this.selectedEvent && this.selectedEvent.date) {
        try {
          const eventDate = new Date(this.selectedEvent.date);
          if (!isNaN(eventDate.getTime())) {
            // Set validTill to 1 day after event date
            eventDate.setDate(eventDate.getDate() + 1);
            validTillDate = eventDate;
          }
        } catch (eventDateError) {
          console.warn('Invalid event date, using default validTill');
        }
      } else {
        // Default to 30 days from now
        validTillDate.setDate(validTillDate.getDate() + 30);
      }

      // Validate the date object
      if (isNaN(validTillDate.getTime())) {
        console.warn('Invalid validTill date created, using fallback');
        const fallback = new Date();
        fallback.setDate(fallback.getDate() + 30);
        return fallback.toISOString();
      }

      return validTillDate.toISOString();
    } catch (error) {
      console.error('Error creating validTill date:', error);
      // Fallback to 30 days from now
      const fallback = new Date();
      fallback.setDate(fallback.getDate() + 30);
      return fallback.toISOString();
    }
  }

  validateFeed(popupObj) {
    try {
      let validateFlag = true;

      // Reset validation errors
      this.validationErrors = {
        eventError: '',
        titleError: '',
        contentError: '',
        linkError: '',
        recipientError: ''
      };

      // Validate event selection
      if (!this.selectedEvent) {
        validateFlag = false;
        this.validationErrors.eventError = 'Please select an event for the broadcast';
        this.popUpMessage = 'Please select an event for the broadcast';
        this.popupTitle = 'Event Required';
        this.cancleButton = false;
        popupObj.showChildModal();
        return validateFlag;
      } else if (!(this.feed.title + '').trim()) {
        validateFlag = false;
        this.validationErrors.titleError = CONSTANT_MESSAGES.ERROR_MESSAGE_SUBJECT;
        this.popUpMessage = CONSTANT_MESSAGES.ERROR_MESSAGE_SUBJECT;
        this.popupTitle = 'Subject Required';
        this.cancleButton = false;
        popupObj.showChildModal();
        return validateFlag;
      } else if (!(this.feed.content + '').trim()) {
        validateFlag = false;
        this.validationErrors.contentError = CONSTANT_MESSAGES.ERROR_MESSAGE_CONTENT;
        this.popUpMessage = CONSTANT_MESSAGES.ERROR_MESSAGE_CONTENT;
        this.popupTitle = 'Content Required';
        this.cancleButton = false;
        popupObj.showChildModal();
        return validateFlag;
      } else if (this.checkUrl()) {
        validateFlag = false;
        this.validationErrors.linkError = CONSTANT_MESSAGES.INVALID_URL;
        this.popUpMessage = CONSTANT_MESSAGES.INVALID_URL;
        this.popupTitle = 'Invalid URL';
        this.cancleButton = false;
        popupObj.showChildModal();
      } else if ((this.selectedGroupList.length === 0) && !this.feed.sendToAllGroups && !this.feed.sendToAllMembers && (this.selectedMemberList.length === 0)) {
        validateFlag = false;
        this.validationErrors.recipientError = CONSTANT_MESSAGES.SELECT_RECIPIENTS_BROADCAST;
        this.popUpMessage = CONSTANT_MESSAGES.SELECT_RECIPIENTS_BROADCAST;
        this.popupTitle = 'Recipients Required';
        this.cancleButton = false;
        popupObj.showChildModal();
        return validateFlag;
      }
      return validateFlag;
    } catch (e) {
      console.log(e);
    }
  }

  actionOnCriteria(para, popupObj) {
    if (this.selectedCriteria !== para) {
      this.selectedCriteria = para;
      this.criteria.allMember = false;
      this.criteria.allMember = false;
      this.criteria.specificMembers = false;
      switch (para) {
        case 'All Members':
          if (this.memberList.length === 0) {
            this.selectedCriteria = '';
            this.popUpMessage = CONSTANT_MESSAGES.NO_MEMBER_AVAILABLE;
            this.popupTitle = 'No Members';
            this.cancleButton = false;
            popupObj.showChildModal();
          } else {
            this.selectedMemberList = [];
            this.setChecked = [];
            this.unSelectSpecificGroup();
            this.criteria.allMember = true;
            this.feed.sendToAllMembers = true;
          }
          break;
        case 'Specific Members':
          if (this.memberList.length > 0) {
            this.unSelectSpecificGroup();
            this.feed.sendToAllMembers = false;
            this.criteria.specificMembers = true;
            this.ideal = false;
            this.cancelForReset = true;
            this.pagination(this.pageOptions, 1);
          } else {
            this.selectedCriteria = '';
            this.popUpMessage = CONSTANT_MESSAGES.NO_MEMBER_AVAILABLE;
            this.popupTitle = 'No Members';
            this.cancleButton = false;
            popupObj.showChildModal();
          }
          break;
        case 'All Groups':
          if (this.groupList.length === 0) {
            this.selectedCriteria = '';
            this.popUpMessage = CONSTANT_MESSAGES.NO_GROUP_AVAILABLE;
            this.popupTitle = 'No Groups';
            this.cancleButton = false;
            popupObj.showChildModal();
          } else {
            this.unSelectSpecificMembers();
            this.feed.groups = [];
            this.selectedGroupList = [];
            this.criteria.allGroup = true;
            this.feed.sendToAllGroups = true;
          }
          break;
        case 'Specific Groups':
          if (this.groupList.length > 0) {
            this.unSelectSpecificMembers();
            this.cancelForReset = true;
            this.criteria.specificGroup = true;
            this.ideal = false;
          } else {
            this.selectedCriteria = '';
            this.popUpMessage = CONSTANT_MESSAGES.NO_GROUP_AVAILABLE;
            this.popupTitle = 'No Groups';
            this.cancleButton = false;
            popupObj.showChildModal();
          }
          break;
      }
    }
    this.isopen = false;
  }

  pagination(pageOptions, pageNo) {
    this.currentPage = 1;
    if (pageOptions) {
      this.pageOptions = pageOptions;
    }

    let vendorObject = {
      'vendorId': this.getVendorId(),
      perPage: this.pageOptions.noOfPageItem,
      pageNumber: pageNo ? pageNo : this.pageOptions.currentPage,
      filters: []
    };
    if (this.AddNewMemberFlag) {
      vendorObject.filters = [{
        type: 'exclude',
        values: this.setChecked
      }];
    }
    if ((this.search + '').trim()) {
      vendorObject['filters'].push({
        type: 'search',
        values: this.search
      });
      if (this.tableVariable) {
        this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
      }
    }
    this.getMemberListByVendor(vendorObject);
  }

  getMemberListByVendor(vendorObj) {
    try {
      this.loaderEvent.fire(false);
      let that;
      this.appService.getListOfMember(vendorObj).then((result: any) => {
        if (result.status === 'SUCCESS') {
          this.memberList = result.memberList.filter(member => !member.isBlackListed);
          this.totalSizeOfList = result.total;
          this.noMemberAvailable = (result.total > 0);
          this.memberList.map(function (mem) {
            if (!mem.isBlackListed) {
              mem.enable = 'Active';
            } else {
              mem.enable = 'Inactive';
            }
            mem.signedUpOn = moment(mem.signedUpOn).format('DD/MM/YYYY');
            return mem;
          });
        }
        this.setCheckedList();
        that = this;
        if (this.selectedMemberList.length > 0) {
          this.memberList = this.memberList.filter(function (rec: any) {
            if (_.some(that.selectedMemberList, rec)) {
              rec.isChecked = true;
            }
            return rec;
          });
          this.setAllMemberCheck.fire(true);
        }
        this.loaderEvent.fire(true);
      }).catch((err) => {
        this.popUpMessage = err;
        this.loaderEvent.fire(true);
      });

    } catch (e) {
      console.log(e);
    }
  }

  selectSpecificMembers(memberObj: any) {
    try {
      if (memberObj.isChecked) {
        this.selectedMemberList.push(memberObj);
        this.selectNewMembers.push(memberObj);
      } else {
        _.remove(this.selectedMemberList, function (n) {
          return n.userId === memberObj.userId;
        });
        _.remove(this.selectNewMembers, function (n) {
          return n.userId === memberObj.userId;
        });
        if (this.tableVariable && this.tableVariable.allInGroup) {
          this.tableVariable.allInGroup = false;
        }
      }
      this.selectedMemberList = _.uniq(this.selectedMemberList);
    } catch (e) {
      console.log(e);
    }
  }

  selectAllMembers(memberList: any) {
    try {
      let that = this;
      this.setUserIdListTOSendFeed();
      if (!this.tableVariable.allInGroup) {
        for (let rec of this.memberList) {
          _.remove(that.selectedMemberList, function (n) {
            return n.isChecked === false;
          });
          _.remove(that.selectNewMembers, function (n) {
            return n.isChecked === false;
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  setUserIdListTOSendFeed() {
    for (let mem of this.memberList) {
      if ((this.selectedMemberList.indexOf(mem) < 0)) {
        this.selectedMemberList.push(mem);
      }
      if ((this.selectNewMembers.indexOf(mem) < 0)) {
        this.selectNewMembers.push(mem);
      }
    }
    this.selectedMemberList = _.uniq(this.selectedMemberList);
    this.selectNewMembers = _.uniq(this.selectNewMembers);
  }

  public reset() {
    this.resetForm();
  }

  /**
   * Reset the complete form
   */
  public resetForm() {
    try {
      this.setFlagOnReset();
      this.exp = false;
      this.search = '';
      if (this.tableVariable) {
        this.tableVariable.allInGroup = false;
      }
      this.unSelectSpecificGroup();
      this.selectedCriteria = '';
      this.criteria.specificGroup = false;
      this.unSelectSpecificMembers();
      this.groupList.map(function (rec: any) {
        if (rec.checked === true) {
          rec.checked = false;
        }
        return;
      });
      this.selectNewMembers = [];
      this.pagination(this.pageOptions, 1);

      // Reset event selection
      this.selectedEvent = null;
      this.selectedEventId = '';
      this.feed.eventId = '';
      this.feed.facilityId = '';
      this.feed.eventName = '';
      this.feed.title = '';
      this.feed.content = '';
      this.feed.broadcastLink = '';
      this.feed.groups = [];
      this.feed.members = [];
      this.feed.sendToAllMembers = false;
      this.feed.sendToAllGroups = false;

      // Reset file upload
      this.filesToUpload = '';
      this.fileUrl = null;
      if (this.fileUploadInputVariable) {
        this.fileUploadInputVariable.nativeElement.value = '';
      }

      // Reset validation errors
      this.validationErrors = {
        eventError: '',
        titleError: '',
        contentError: '',
        linkError: '',
        recipientError: ''
      };

      // Reset UI state
      this.ideal = true;
      this.cancelForReset = false;
      this.addGroupFlagCancel = false;
      this.AddNewMemberFlag = false;
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Go to compose message (save member selection) - FIXED METHOD
   */
  public goToComposeMessage(popUpObj: any) {
    if (this.checkMemberListForSelection()) {
      if (this.tableVariable) {
        this.tableVariable.allInGroup = false;
      }
      this.setFlagOnReset();
      this.AddNewMemberFlag = false;
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.SELECT_MEMBER_FEED;
      this.popupTitle = 'Selection Required';
      this.cancleButton = false;
      if (popUpObj && popUpObj.showChildModal) {
        popUpObj.showChildModal();
      }
    }
    this.selectedMemberList = _.uniq(this.selectedMemberList);
  }

  /**
   * Show selected items using custom modal components
   */
  public showSelectedItems(popupObj: any, ViewSelectedpopUpObj: any, ViewSelectedGroupPopUpObj: any): void {
    if (this.selectedCriteria === 'Specific Members' && this.selectedMemberList.length > 0) {
      this.showSelectedMembersWithCustomModal(ViewSelectedpopUpObj);
    } else if (this.selectedCriteria === 'Specific Groups' && this.selectedGroupList.length > 0) {
      this.showSelectedGroupsWithCustomModal(ViewSelectedGroupPopUpObj);
    } else {
      // Show general info if nothing selected
      this.popUpMessage = 'No recipients have been selected yet.';
      this.popupTitle = 'No Selection';
      if (popupObj && popupObj.showChildModal) {
        popupObj.showChildModal();
      }
    }
  }

  /**
   * Show selected members using custom app-view-members component
   */
  private showSelectedMembersWithCustomModal(ViewSelectedpopUpObj: any): void {
    this.popupTitle = `Selected Members (${this.selectedMemberList.length})`;

    if (ViewSelectedpopUpObj && ViewSelectedpopUpObj.showChildModal) {
      ViewSelectedpopUpObj.showChildModal();
    }
  }

  /**
   * Show selected groups using custom app-view-groups component
   */
  private showSelectedGroupsWithCustomModal(ViewSelectedGroupPopUpObj: any): void {
    this.popupTitle = `Selected Groups (${this.selectedGroupList.length})`;

    if (ViewSelectedGroupPopUpObj && ViewSelectedGroupPopUpObj.showChildModal) {
      ViewSelectedGroupPopUpObj.showChildModal();
    }
  }

  /**
   * Remove member from selection - Enhanced for custom modal
   */
  public removeFromSelection(member: any): void {
    if (!member) return;

    // Remove from selected member list
    _.remove(this.selectedMemberList, (n) => {
      return n.userId === member.userId;
    });

    // Also remove from new members list if present
    _.remove(this.selectNewMembers, (n) => {
      return n.userId === member.userId;
    });

    // Update criteria if no members left
    if (this.selectedMemberList.length === 0 && this.selectedCriteria === 'Specific Members') {
      this.selectedCriteria = '';
      this.criteria.specificMembers = false;
      this.ideal = true;
    }

    // Update member list checkboxes
    this.updateMemberCheckboxes();

    console.log('Member removed from selection:', member.firstName + ' ' + member.lastName);
    console.log('Remaining selected members:', this.selectedMemberList.length);
  }

  /**
   * Remove group from selection - Enhanced for custom modal
   */
  public removeGroupFromSelection(group: any): void {
    if (!group) return;

    // Remove from selected group list
    if (_.some(this.selectedGroupList, group)) {
      _.remove(this.selectedGroupList, (n) => {
        return n._id === group._id;
      });
    }

    // Update criteria if no groups left
    if (this.selectedGroupList.length === 0 && this.selectedCriteria === 'Specific Groups') {
      this.selectedCriteria = '';
      this.criteria.specificGroup = false;
      this.ideal = true;
    }

    // Refresh group list to update checkboxes
    this.getGroupListByVendor();

    console.log('Group removed from selection:', group.name);
    console.log('Remaining selected groups:', this.selectedGroupList.length);
  }

  /**
   * Update member list checkboxes after removal
   */
  private updateMemberCheckboxes(): void {
    if (this.memberList && this.memberList.length > 0) {
      this.memberList.forEach(member => {
        member.isChecked = this.selectedMemberList.some(selected => selected.userId === member.userId);
      });

      // Update table state if needed
      if (this.tableVariable) {
        this.setCheckedList();
      }
    }
  }

  saveGroupList(popupObj) {
    let flag = false;
    for (let group of this.groupList) {
      if (group.checked) {
        if (!_.some(this.selectedGroupList, group)) {
          this.selectedGroupList.push(group);
        }
      } else {
        if (_.some(this.selectedGroupList, group)) {
          _.remove(this.selectedGroupList, function (n) {
            return n._id === group._id;
          });
        }
      }
    }
    for (let group of this.groupList) {
      if (group.checked) {
        flag = true;
        break;
      }
    }
    this.selectedGroupList = _.uniq(this.selectedGroupList);
    if (!flag) {
      this.popUpMessage = CONSTANT_MESSAGES.SELECT_Group_FEED;
      this.popupTitle = 'Selection Required';
      this.cancleButton = false;
      popupObj.showChildModal();
    } else {
      this.criteria.specificGroup = false;
      this.cancelForReset = false;
      this.ideal = true;
      this.AddNewMemberFlag = false;
      this.addGroupFlagCancel = false;
    }
  }

  setCheckedList() {
    try {
      let flagAllChecked = true;
      for (let mem of this.memberList) {
        if (!mem.isChecked) {
          flagAllChecked = false;
          break;
        }
      }
      if (this.tableVariable) {
        if (flagAllChecked) {
          this.tableVariable.allInGroup = true;
        } else {
          this.tableVariable.allInGroup = false;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  addRecipants() {
    this.exp = false;
    this.search = '';
    this.selectedMemberList = _.uniq(this.selectedMemberList);
    let that = this;
    this.ideal = false;
    this.cancelForReset = false;
    switch (this.selectedCriteria) {
      case 'Specific Members':
        this.setChecked = [];
        this.selectNewMembers = [];
        for (let item of this.selectedMemberList) {
          this.setChecked.push(item.userId);
        }
        this.criteria.specificMembers = true;
        this.addGroupFlagCancel = false;
        this.AddNewMemberFlag = true;
        this.pagination(this.pageOptions, 1);
        break;
      case 'Specific Groups':
        this.ideal = false;
        this.addGroupFlagCancel = true;
        this.cancelForReset = false;
        this.AddNewMemberFlag = false;
        this.criteria.specificGroup = true;
        this.groupList = this.groupList.filter(function (rec: any) {
          if (!_.some(that.selectedGroupList, rec)) {
            return rec;
          }
        });
        break;
    }
  }

  removeMemberList() {
    this.criteria.specificMembers = false;
    let that = this;
    for (let member of this.memberList) {
      for (let item of this.selectedMemberList) {
        if (member.userId === item.userId) {
          member.isChecked = true;
        } else {
          member.isChecked = false;
        }
        break;
      }
    }
    this.AddNewMemberFlag = false;
  }

  removeGroupFromSelectionOnCancel() {
    this.AddNewMemberFlag = false;
    this.addGroupFlagCancel = false;
    this.cancelForReset = false;
    this.ideal = true;
  }

  /**
   * Check if member list has selection - REQUIRED METHOD
   */
  checkMemberListForSelection() {
    return this.selectNewMembers.some(item => {
      return item.isChecked;
    });
  }

  expand() {
    if (!this.search) {
      this.exp = !this.exp;
    }

    if (this.selectedCriteria == 'Specific Members') {
      this.pagination(this.pageOptions, 1);
    }
  }

  /**
   * Set flag on reset - REQUIRED METHOD
   */
  setFlagOnReset() {
    this.criteria.specificMembers = false;
    this.isopen = false;
    this.ideal = true;
    this.cancelForReset = false;
  }

  unSelectSpecificMembers() {
    this.feed.sendToAllMembers = false;
    this.selectedMemberList = [];
    this.setChecked = [];
  }

  unSelectSpecificGroup() {
    this.feed.sendToAllGroups = false;
    this.feed.groups = [];
    this.selectedGroupList = [];
  }

  checkUrl() {
    let regEx = /^http(s)?:\/\/(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
    if (this.feed.broadcastLink) {
      if (!regEx.test(this.feed.broadcastLink)) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  /**
   * Check if broadcast can be sent
   */
  public canSendBroadcast(): boolean {
    return this.selectedEvent &&
      this.feed.title.trim() &&
      this.feed.content.trim() &&
      this.selectedCriteria &&
      (this.feed.sendToAllMembers ||
        this.feed.sendToAllGroups ||
        this.selectedMemberList.length > 0 ||
        this.selectedGroupList.length > 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/facility/event/broadcast/event-broadcast.component.ts